import React, { useCallback, useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { bapi } from '@/lib/billingApi';
import { StatusPill } from '@/components/billing/StatusPill';
import { AuditTrail, RefundList, TxnFacts } from './TxnFacts';
import { TxnActions } from './TxnActions';
import { RefundDialog } from './RefundDialog';
import { GatewayTag, KIND_LABEL, PRODUCT_SHORT, TestTag, statusText } from './shared';

export const TransactionDrawer = ({ id, onClose, onChanged }) => {
  const [d, setD] = useState(null);
  const [refund, setRefund] = useState(false);
  const [busy, setBusy] = useState('');

  const load = useCallback(() => {
    if (id) bapi(`/admin/billing/transactions/${id}`).then(setD).catch((e) => toast.error(e.message));
  }, [id]);
  useEffect(() => { setD(null); load(); }, [load]);

  const run = async (key, path, body, msg) => {
    setBusy(key);
    try {
      await bapi(`/admin/billing/transactions/${id}/${path}`, { method: 'POST', body: body || {} });
      toast.success(msg);
      load();
      onChanged();
      return true;
    } catch (e) {
      toast.error(e.message);
      return false;
    } finally { setBusy(''); }
  };

  const p = d?.payment;
  return (
    <Sheet open={!!id} onOpenChange={(o) => { if (!o) onClose(); }}>
      <SheetContent className="w-full sm:max-w-xl overflow-y-auto" data-testid="txn-drawer">
        <SheetHeader className="text-left">
          <SheetTitle className="flex flex-wrap items-center gap-2 pr-6">
            {p ? <>{PRODUCT_SHORT[p.product_id] || p.product_name}<GatewayTag gateway={p.gateway} /><StatusPill status={p.status} label={statusText(p.status)} testId="txn-drawer-status" />{p.simulated && <TestTag />}</> : 'Transaction'}
          </SheetTitle>
          <SheetDescription>{p ? `${KIND_LABEL[p.kind] || p.kind} · ${p.user_email}` : 'Loading…'}</SheetDescription>
        </SheetHeader>
        {!p ? <div className="py-16 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-[#00247D]" /></div> : (
          <div className="space-y-6 mt-6">
            <TxnActions p={p} receipt={d.receipt} busy={busy} run={run} onRefund={() => setRefund(true)} />
            <TxnFacts p={p} receipt={d.receipt} sub={d.subscription} />
            <RefundList refunds={p.refunds || []} />
            <AuditTrail rows={d.audit || []} />
            <RefundDialog open={refund} p={p} onClose={() => setRefund(false)} onDone={() => { setRefund(false); load(); onChanged(); }} />
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
};
